export const environment = {
  production: false,
  envName: "dev",
  applicationName: "Inmar.Healthcare.Recon",
  applicationApplinkFeature: "ReconUI",
  rootUrl: "https://dev-web-recon.healthcare.inmar.com",
  healthcareTopBar:
    "https://dev-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js",
  auth0: {
    domain: "https://qa-login.healthcare.inmar.com",
    clientId: "SQTdtQny4EsnivEhDxz3db4KqzCVFtUi",
    refreshToken: true,
    scope: "openid profile email",
  },
  authZApiRoot: {
    url: "https://dev-api-authz.healthcare.inmar.com/v1.0",
    audience: "https://dev-api-authz.healthcare.inmar.com",
  },
  reconApiRoot: {
    url: "https://dev-api-recon.healthcare.inmar.com/v1.0",
    audience: "https://dev-api-recon.healthcare.inmar.com",
  },
  rebrandStartDate: "11-01-2019",
  globalFilterRefreshInterval: 60000,
  appInsights: {
    instrumentationKey: "",
  },
  googleAnalytics: {
    key: "",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts